<template>
	<div class="main_section bookings-page" :class="($route.name === 'int_bookings') ? 'p-3' : ''">

		<!-- <div class="logo" v-if="$route.name === 'int_bookings'">
            <img :src="require('@/assets/images/logo/Logotipo_Verde.png')" alt="logo" class="w-10 mr-4 align-middle">
            <span style="color: #476061" class="logo-text -my-1 align-middle"><em>My</em> Vila Galé</span>
        </div> -->

		<div>
			<vs-popup :title="$t('aviso')" :active.sync="show_pop_up_dup">
		      <div>
		      	<p>{{pop_up_data.message}}</p>
		      </div>
		      <div class="text-right mt-4">
		      	<vs-button class="sm:w-full md:w-1/3 lg:w-1/4 m-1" color="success" type="filled" v-on:click="cancel_reservations">{{$t('yes')}}</vs-button>
				<vs-button class="sm:w-full md:w-1/3 lg:w-1/4 m-1" color="danger" type="filled" v-on:click="show_pop_up_dup=false">{{$t('no')}}</vs-button>
		      </div>
		    </vs-popup>
		</div>
		
		<div>
			<div v-if="$route.name === 'int_bookings'">
				<vs-popup :title="$t('Pesquisa')" :active.sync="show_pop_up_int_booking">
					<div class="inline-block w-full">
						<div class="flex">
							<vs-input class="w-full" type="number" :placeholder="$t('rsv_number')" @focus="keyboard_show" data-layout="numeric" v-model="int_booking_rsv.num_reserva"/>
							<div class="mr-1 ml-1"></div>
							<vs-input class="w-full" :placeholder="$t('n_quarto')" @focus="keyboard_show" data-layout="numeric" v-model="int_booking_rsv.room_number"/>
						</div>
					</div>
					<div class="text-right mt-4">
						<vs-button class="sm:w-full md:w-1/3 lg:w-1/4 m-1" color="primary" type="filled" v-on:click="search_rsv">{{$t('Pesquisar')}}</vs-button>
					</div>
			    </vs-popup>
			</div>

			<div v-if="$route.name === 'int_bookings'"> 
				<h1 class='my-5'>{{$t('appointments')}}</h1>
				<h4 class="mt-2">{{user.hotel.hotel_name}}</h4>
			</div>

			<div class="text-right mt-6 mb-3" v-if="$route.name === 'int_bookings'">
				<router-link class="inline-block" :to="($route.name === 'int_bookings') ? {name: 'int_my_bookings', params: $route.params} : {name: 'my_bookings'}"><vs-button color="primary">{{$t('returnButton')}}</vs-button></router-link>
			</div>

			<div class="w-full">
				<vx-card class="mt-8 mb-8 text-center" v-if="client_reservations.length == 0 && $route.name !== 'int_bookings'">
					{{$t('no_reservations_available')}}
				</vx-card>
				<vx-card class="mt-8 mb-8 h-fit" v-else>
					
					<div class="lg:w-1/2 w-full float-right" style="display: block;" v-if="information != null">
						<vx-card style="margin-bottom: 20px;">
							<h3 class="mb-3">{{$t('Informations')}}</h3>
							<QuillPresentInfo v-bind:info="information"style="max-height: 300px;padding: 0 5px 0 0; overflow-y: scroll;"></QuillPresentInfo>
						</vx-card>
					</div>

					<div class="lg:w-1/2 w-full">
						<div v-if="$route.name === 'int_bookings'">
							<small class="block">{{$t('tipo_de_marcacao')}}</small>
							<div class="flex items-center">
								<v-select class="vue-select lg:w-2/3 w-full" :append-to-body="true" :clearable="false" :searchable="false" v-model="rsv_type_selected" v-on:input="reset_children_selects('space_type')" :options="rsv_types" label="label">
								</v-select>
								<SearchIcon v-show="rsv_type_selected != null && rsv_type_selected.name === 'Reserva'" class="ml-1 cursor-pointer text-primary" v-on:click="show_pop_up_int_booking = true"></SearchIcon>
							</div>
							
						</div>

						<div v-if="rsv_type_selected != null && rsv_type_selected.name === 'Reserva'">
							<div class="lg:w-2/3 w-full mt-5">
								<small class="block">{{$t('rsv_number')}}</small>
								<vs-input disabled class="w-full" placeholder="" v-model="user.hotel.num_reserva"/>
							</div>
							<div class="lg:w-2/3 w-full mt-5">
								<small class="block">{{$t('n_quarto')}}</small>
			     				<vs-input disabled class="w-full" placeholder="" v-model="user.hotel.room_number"/>
			     			</div>

			     			<div class="lg:w-2/3 w-full mt-5">
								<small class="block">{{$t('nome')}}</small>
			     				<vs-input disabled class="w-full" placeholder="" v-model="user.hotel.nome"/>
			     			</div>
						</div>

						<div v-if="rsv_type_selected != null && rsv_type_selected.name === 'Passante'">
							<div class="inline-block lg:w-2/3 w-full mt-5">
								<small class="block">{{$t('nome')}}</small>
								<vs-input :disabled="space_type_selected !== null" class="w-full" placeholder="" v-model="int_booking_rsv.name" @focus="keyboard_show" data-layout="normal"/>
								<div class="mr-1 ml-1"></div>
							</div>
							<div class="inline-block lg:w-2/3 w-full mt-5">
								<small class="block">Email</small>
								<vs-input :disabled="space_type_selected !== null" class="w-full" placeholder="" v-model="int_booking_rsv.email" @focus="keyboard_show" data-layout="normal"/>
								<div class="mr-1 ml-1"></div>
							</div>
						</div>

						<div v-if="$route.name !== 'int_bookings'">
							<small class="block">{{$t('rsv_number')}}</small>
							<v-select class="vue-select lg:w-2/3 w-full" :searchable="false" :append-to-body="true" :clearable="false" v-model="client_reservations_selected" :options="client_reservations" label="label">
							</v-select>

							<div v-if="client_reservations_selected != null">
								<div class="flex flex-row justify-between px-8 mt-5 mb-5">
									<p class="text-left">
										<span class="block">{{$t('hotel')}}</span>
										<span class="text-2xl font-semibold">{{client_reservations_selected.hotel.hvg_desc}}</span>
									</p>
								</div>
								<div class="flex flex-row rsv_data justify-between px-8 mt-5 mb-5">
									<p class="text-center">
										<span class="block">Check-In</span>
										<span class="text-2xl font-semibold">{{date_formated(client_reservations_selected.current_data_check_in)}}</span>
									</p>
									<p class="text-center">
										<span class="block">Check-Out</span>
										<span class="text-2xl font-semibold">{{date_formated(client_reservations_selected.current_data_check_out)}}</span>
									</p>
									<p class="text-center">
										<span class="block">{{$t('room_number')}}</span>
										<span class="text-2xl font-semibold">
											<span v-if="client_reservations_selected.current_room_number && client_reservations_selected.cod_status > 3">
												{{client_reservations_selected.current_room_number}}
											</span>
											<span v-else>
												---
											</span>
										</span>
									</p>
								</div>
							</div>
						</div>

						<div v-if="(($route.name !== 'int_bookings' && client_reservations_selected != null ) || (rsv_type_selected != null && rsv_type_selected.name === 'Passante' && int_booking_rsv.name !== '') || (rsv_type_selected != null && rsv_type_selected.name === 'Reserva' && user.hotel.num_reserva !== null))" :class="($route.name === 'int_bookings') ? 'mt-5' : ''">
							<small class="mt-5 block">{{$t('type_of')}} {{$t('space')}}</small>
							<v-select class="vue-select lg:w-2/3 w-full" :append-to-body="true" :clearable="false" :searchable="false" v-model="space_type_selected" v-on:input="reset_children_selects('space_type')" :options="spaces_types" :label="'name'">
							</v-select>
						</div>

						<div class="mt-5 booking-date" v-if="show_select_space_hotel">
							<small class="block">{{$t('date')}}</small>
							<datepicker class="lg:w-2/3 w-full"
								:disabledDates="datepicker.disabledDates"
								v-model="booking_date_selected"
								input-class="w-full"
								:language="datepicker.languages[$i18n.locale]"
								:format="($i18n.locale !== 'en') ? 'dd-MM-yyyy' : 'yyyy-MM-dd'">
							</datepicker>
						</div>

						<div class="mt-5" v-if="show_select_space_hotel">
							<small class="block">{{$t('space')}}</small>
							<v-select class="vue-select lg:w-2/3 w-full" :append-to-body="true" :clearable="false" :searchable="false" v-model="space_hotel_selected" v-on:input="reset_children_selects('space_hotel')" :options="space_type_selected.hotel_spaces" :label="'name'">
							</v-select>
						</div>

						<div class="mt-5" v-if="show_select_service_type">
							<small class="block">{{$t('type_of')}} {{$t('service')}}</small>
							<v-select class="vue-select lg:w-2/3 w-full" :append-to-body="true" :clearable="false" :searchable="false" v-model="service_type_selected" :options="service_types" label="service_name">
							</v-select>
						</div>
					</div>

						<div v-if="load_table" class="table_schedule_wrapper mt-8">
							<!-- <router-link v-if="rsv_type_selected !== 'Passante'" class="inline-block float-right" :to="($route.name === 'int_bookings') ? {name: 'int_my_bookings'} : {name: 'my_bookings'}"><vs-button color="primary">{{$t('consult')}}</vs-button></router-link> -->
							<h4 class="text-center mb-3">{{$t('horarios')}}</h4>
							<div class="controls text-center mb-2" v-if="rsv_type_selected != null && rsv_type_selected.name !== 'Passante'">
								<span v-show="date_formated(datepicker.disabledDates.to) != date_formated(booking_date_selected)"><arrow-left-circle-icon v-on:click="addDays(-1)" size="1.5x" class="color-primary align-middle inline-block cursor-pointer mr-1"></arrow-left-circle-icon></span>
								<h4 class="align-middle inline-block m-0">{{date_formated(booking_date_selected)}}</h4>
								<span v-show="date_formated(datepicker.disabledDates.from) != date_formated(booking_date_selected)"><arrow-right-circle-icon v-on:click="addDays(1)" size="1.5x" class="color-primary align-middle inline-block cursor-pointer ml-1"></arrow-right-circle-icon></span>
							</div>
							<vs-table class="schedules-table mt-2" stripe :data="comp_schedules" :noDataText="$t('no_shedules')">
							  <template slot="thead">
									<vs-th>
										{{$t('horario')}}
									</vs-th>
									<vs-th>
									    {{$t('availability')}}
									</vs-th>
									<vs-th>
										{{$t('people_n')}}
									</vs-th>
								</template>	

								<template slot-scope="{data}">
									<vs-tr :key="idx" v-for="(item, idx) in data">
										<vs-td>
											{{get_hour_interval_str(item.start_time, item.end_time)}}
										</vs-td>

										<vs-td>
											{{item.person_disponibility}}
										</vs-td>

										<vs-td class="text-left">
											<div class="inline-block"><vs-input-number min="0" :max="get_schedule_max_pax(item)" v-model="item.booking_num_pessoas" v-on:input="update_persons_schedule_val(item.booking_num_pessoas, item)" :is-disabled="true" /></div>
										</vs-td>
									</vs-tr>
								</template>
							</vs-table>
						</div>
						<div v-if="load_dish_table" class="table_dish_wrapper mt-8">
							<h4 class="text-center">Carta</h4>
							<vs-table class="dishs-table mt-2" stripe :data="comp_subcapitulos" :noDataText="$t('no_shedules')">
							  <template slot="thead">
									<vs-th>
										{{$t('dish')}}
									</vs-th>
									<vs-th>
										{{$t('people_n')}}
									</vs-th>
								</template>	

								<template slot-scope="{data}">
									<vs-tr :key="idx" v-for="(item, idx) in data">
										<vs-td>
											{{item.nome}}
										</vs-td>
										<vs-td class="text-left">
											<div class="inline-block"><vs-input-number min="0" :max="(total_dish_num_pessoas === total_schedule_num_pessoas) ? item.num_pessoas_dish : total_schedule_num_pessoas" v-model="item.num_pessoas_dish"/></div>
										</vs-td>
									</vs-tr>
								</template>
							</vs-table>
						</div>
						<div class="w-full mt-6" v-if="can_confirm">
							<div class="w-full">
								<small class="block">{{$t('notes')}}</small>
								<textarea @focus="keyboard_show" class="observations-textarea" data-layout="normal" v-model="observations">{{observations}}</textarea>
							</div>
							<div class="w-full" v-if="rsv_type_selected != null && rsv_type_selected.name !== 'Passante' && space_type_selected.space_type_id == 1">
								<vs-checkbox v-model="associate_rsv">{{$t('associate_rsv')}}</vs-checkbox>
							</div>
							<div class="vx-row">
								<div class="vx-col md:w-1/2 lg:w-1/3 w-full">
									<vs-input v-if="associate_rsv" @focus="keyboard_show" data-layout="numeric" v-model="associated_rsv_number" class="w-full mt-3" type="number" :label="$t('rsv_number')"/>
								</div>
								<div class="vx-col md:w-1/2 lg:w-1/3 w-full">
									<vs-input v-if="associate_rsv" @focus="keyboard_show" data-layout="numeric" v-model="associated_rsv_room_number" class="w-full mt-3" type="number" :label="$t('room_number')"/>
								</div>
							</div>
						</div>
						<div class="text-center">
							<vs-button :disabled="!can_confirm" class="mt-4 mx-auto" color="primary" v-on:click="process_confirmation">{{$t('finishOrder')}}</vs-button>
						</div>

				</vx-card>
				<vue-touch-keyboard class="v-touch-keyboard" :options="keyboard.options" v-if="keyboard.visible && $route.params.pos == 1 && !isMobile()" :layout="keyboard.layout" :cancel="keyboard_hide" :accept="keyboard_accept" :input="keyboard.input" />
			</div>
		</div>
	</div>
</template>

<script>
import Datepicker from 'vuejs-datepicker';
import {en, es, ptBR, de, fr} from 'vuejs-datepicker/dist/locale';
import moment from 'moment';
import { SearchIcon } from 'vue-feather-icons'
import { ArrowLeftCircleIcon } from 'vue-feather-icons'
import { ArrowRightCircleIcon } from 'vue-feather-icons'
import QuillPresentInfo from '@/views/components/QuillPresentInfo.vue'

import VueTouchKeyboard from "vue-touch-keyboard";
import style from "vue-touch-keyboard/dist/vue-touch-keyboard.css"; // load default style

export default {
	components: {
		Datepicker,
		SearchIcon,
		vueTouchKeyboard: VueTouchKeyboard.component,
		ArrowLeftCircleIcon,
		ArrowRightCircleIcon,
		QuillPresentInfo,
	},
	data(){
		return {
			user: JSON.parse(localStorage.getItem('userSession')),
			user_token: null,
			pop_up_data: {},
			show_pop_up_dup: false,
			rsv_types: [
				{ name: 'Reserva', label: this.$t('Reserva') },
				{ name: 'Passante', label: this.$t('Passante') }
			],
			spaces_types: [],
			schedules: {},
			triggerComp: 0,
			service_types: [],
			menus: null,
			int_booking_rsv: {num_reserva: '', room_number: '', name: ''},
			rsv_type_selected: null,
			room_date_selected: null,
			reservation_data: null,
			space_type_selected: null,
			show_pop_up_int_booking: false,
			space_hotel_selected: null,
			observations: '',
			associate_rsv: false,
			associated_rsv_number: null,
			associated_rsv_room_number: null,
			service_type_selected: null,
			booking_date_selected: null,
			booking_persons: {},
			keyboard: {
				visible: false,
		      	layout: "normal",
		      	input: null,
		      	options: {
			        useKbEvents: false
			    }
		  	},
			datepicker: {
				disabledDates: {
					to: moment().startOf('day').toDate()
		        },
		        languages: {
		        	en: en,
		        	pt: ptBR,
		        	br: ptBR,
		        	de: de,
		        	fr: fr,
		        	es: es,
		        }
			},
			client_reservations: [],
			client_reservations_selected: null,
			information: null,
			informations: [],
		}
	},
	methods: {
		addDays: function(val) {
			let bds_tmp = moment(this.booking_date_selected).add(val, 'days').toDate();
			if(this.datepicker.disabledDates.to <= bds_tmp && this.datepicker.disabledDates.from >= bds_tmp) {
				this.booking_date_selected = bds_tmp;
			}
		},
		date_formated: function(d) {
			return moment(d).format('DD-MM-YYYY');
		},
		get_schedule_max_pax: function(item) {
			if(this.rsv_type_selected != null && this.rsv_type_selected.name === 'Passante') {
				return item.person_disponibility;
			}
			if (this.total_schedule_num_pessoas == this.room_date_selected.num_pessoas) {
				return item.booking_num_pessoas;
			}

			//a menos que seja restaurante nao e possivel o overbooking nos horarios
			if(this.space_type_selected.space_type_id != 1 && item.person_disponibility <= this.room_date_selected.num_pessoas){
				return item.person_disponibility;
			}
		 
			return this.room_date_selected.num_pessoas;
		},
		reset_children_selects: function(select) {
			if(select === 'num_reserva'){
				this.space_type_selected = null;
				// this.space_type_selected.hotel_spaces = [];
				this.space_hotel_selected = null;
				this.service_type_selected = null;
				this.service_types = [];
			}else if(select === 'space_type') {
				this.space_hotel_selected = null;
				this.service_type_selected = null;
				this.service_types = [];
			}else if(select === 'space_hotel') {
				this.service_type_selected = null;
				this.service_types = [];
			} 
		},
		reset_all: function(get_again, num_reserva = false, clean_user = true) {
			this.room_date_selected = null;
			this.reservation_data = null;
			this.space_type_selected = null;
			this.space_hotel_selected = null;
			this.service_type_selected = null;
			this.int_booking_rsv = {num_reserva: '', room_number: '', name: ''};
			if(this.$route.name === 'int_bookings' && clean_user) {
				this.user.hotel.num_reserva = null;
				this.user.hotel.room_number = null;
				this.user.hotel.nome = null;
			}
			if(get_again) {
				let selects_to_reset = 'space_type';
				if(num_reserva){
					selects_to_reset = 'num_reserva';
				}
				this.reset_children_selects(selects_to_reset);
				this.datepicker.disabledDates.to = moment().startOf('day').toDate();
				if(this.rsv_type_selected != null && this.rsv_type_selected.name == 'Passante') {
					this.user.hotel.check_out.date = moment(this.booking_date_selected).add(2, 'months').format('YYYY-MM-DD');
					this.get_spaces_types();
				}
				if(this.client_reservations_selected != null){
					this.get_spaces_types(this.client_reservations_selected.num_reserva);
				}
			}
		},
		update_persons_schedule_val: function(val, item) {
			let hojeStr = moment().format("YYYYMMDD");
			let dataSelStr = moment(this.booking_date_selected).format("YYYYMMDD");
			
			if (dataSelStr === hojeStr) {
				let agoraHora = parseInt(moment().format("HHmm"));
				let finHora = parseInt(item.end_time.replace(':', '').padStart(4, '0'));
				
				if (agoraHora >= finHora) {
					item.booking_num_pessoas = 0;
					this.notify(this.$t('horario_nao_permitido'), "red");
					return;
				}
			} else if (parseInt(dataSelStr) < parseInt(hojeStr)) {
				item.booking_num_pessoas = 0;
				this.notify(this.$t('horario_nao_permitido'), "red");
				return;
			}

			this.comp_subcapitulos = this.comp_subcapitulos.map((item, idx) => item.num_pessoas_dish = 0); // reset dishs persons
			this.$set(this.booking_persons, item.space_schedule_id, parseInt(val));
		},
		get_hour_interval_str: function(start_time, end_time) {
			return this.$t('str_hour_schedule').replace('{start_time}', this.get_hour_formated(start_time)).replace('{end_time}', this.get_hour_formated(end_time));
		},
		get_hour_formated: function(hour_min) {
			return hour_min.substring(0, 2)+ ":" +hour_min.substring(2);
		},
		search_rsv: function() {
			if(this.int_booking_rsv.num_reserva === '' && this.int_booking_rsv.room_number === '') {
				this.notify(this.$t('obrigatorio_inserir_n_reserva_n_quarto'), 'red');
				return;
			}
			let that = this;
			that.$vs.loading();
			this.$api({
				method: 'get',
				url: '/myvilagale/bookings/search_rsv',
				params: {
					token: this.user_token,
					cod_hotel: this.user.hotel.hotel_id,
					num_reserva: this.int_booking_rsv.num_reserva,
					room_number: this.int_booking_rsv.room_number,
				},
			})
			.then(function (res) {
				that.client_reservations_selected = {num_reserva: res.data.num_reserva};
				that.user.hotel.num_reserva = res.data.num_reserva;
				that.user.hotel.room_number = res.data.current_room_number;
				that.user.hotel.nome = res.data.nome;
				that.user.hotel.check_in.date = res.data.current_data_check_in;
				that.user.hotel.check_out.date = res.data.current_data_check_out;
				let checkIn = moment(that.user.hotel.check_in.date).startOf('day');
				if(checkIn > moment()) { // if checkin greater than today
					that.datepicker.disabledDates.to = checkIn.toDate();
					that.booking_date_selected = that.datepicker.disabledDates.to;// test 4286357
				}
				that.datepicker.disabledDates.from = moment(that.user.hotel.check_out.date).startOf('day').add(1, 'days').toDate();
				that.user.hotel.num_pessoas = parseInt(res.data.rooms[0].pessoas) + parseInt(res.data.rooms[0].num_criancas_pagas) + parseInt(res.data.rooms[0].num_criancas_gratis);
				that.keyboard_hide();
				that.show_pop_up_int_booking = false;
			}) 
			.catch( function (err) {
    			that.notify(err.response.data.message, 'red');
			})
			.then(function() {
				that.$vs.loading.close();
			});
		},
		process_confirmation: function() {
			let that = this;

			if(this.service_type_selected != null && this.$route.name !== 'int_bookings'){
				if(this.service_type_selected.service_type_id == 3
					&& this.date_formated(this.datepicker.disabledDates.from) == this.date_formated(this.booking_date_selected)){
					this.notify(this.$t('no_spaces'), 'red');
				}
			}
			that.$vs.loading();
			this.$api({
				method: 'post',
				url: '/myvilagale/bookings/save_bookings',
				data: {
					token: this.user_token,
					room_number: this.user.hotel.room_number,
					cod_hotel: this.user.hotel.hotel_id,
					name: this.int_booking_rsv.name,
					email: this.int_booking_rsv.email,
					space_type_id: this.space_type_selected.space_type_id,
					num_reserva: (this.rsv_type_selected == null) || 
								(this.rsv_type_selected != null && this.rsv_type_selected.name != 'Passante') 
										? this.client_reservations_selected.num_reserva : null,
					schedules: this.booking_persons,
					date: moment(this.booking_date_selected).format('YYYY-MM-DD'),
					lang: this.$i18n.locale,
					dishs: this.comp_subcapitulos.filter((item, idx) => item.num_pessoas_dish > 0),
					associated_rsv_number: this.associated_rsv_number,
					associated_rsv_room_number: this.associated_rsv_room_number,
					observations: this.observations,
					service_type_id: this.service_type_selected.service_type_id,
					space_hotel_id: this.space_hotel_selected.space_hotel_id,
					is_internal: this.$route.name === 'int_bookings'
				},
			})
			.then(function (res) {
				that.$vs.notify({
                    text: that.$t('rsv_succed'),
                    color:'success',
                    position:'bottom-right',
                    iconPack: 'feather',
                    icon:'icon-check'
                });
                if(that.$route.name === 'int_bookings' && that.rsv_type_selected != null && that.rsv_type_selected.name == 'Passante') {
                	that.$router.push({name: 'int_my_bookings', params: that.$route.params});
                	return;
                }
                //let sts_tmp = that.service_type_selected; // RESET NUM PERSONS BOOKINGS VIA WATCH
                //that.service_type_selected = null; // RESET NUM PERSONS BOOKINGS VIA WATCH
                //that.addDays(1);
                that.get_availabity();
                that.$vs.loading.close();
                //that.service_type_selected = sts_tmp; // RESET NUM PERSONS BOOKINGS VIA WATCH
			}) 
			.catch( function (err) {
				if(err.response.data.error_code == 'DUP') {
	    			that.pop_up_data = {
						message: err.response.data.message,
						ids_to_cancel: err.response.data.ids_rsv_to_cancel,
						send_email: true,
						reservation_id: err.response.data.reservation_id,
					};
	    			that.show_pop_up_dup = true;
	    		} else {
	    			that.$vs.notify({
	                    text: err.response.data.message,
	                    color:'danger',
	                    position:'bottom-right',
	                    iconPack: 'feather',
	                    time: 7000,
	                    icon:'icon-check'
	                });
	    		}
	    		if(err.response.data.error_code == 'DISP') {
	    			that.get_availabity();
	    		} else {
                	that.$vs.loading.close();
	    		}
			})
			.then(function() {
				
			});
		},
		cancel_reservations: function(ids) {
			let that = this;
			that.$vs.loading();
			this.$api({
				method: 'post',
				url: '/myvilagale/bookings/cancel_booking',
				data: {
					token: this.user.usertoken,
					reservation_distribution_ids: that.pop_up_data.ids_to_cancel,
					send_email: that.pop_up_data.send_email ? that.pop_up_data.send_email : true,
					reservation_id: that.pop_up_data.reservation_id,
				},
			})
			.then(function (res) {
                that.process_confirmation();
			}) 
			.catch( function (err) {
    			that.notify('ERR.2', 'red');
			})
			.then(function() {
				that.pop_up_data.ids_to_cancel = [];
				that.pop_up_data.send_email = true;
    			that.show_pop_up_dup = false;
				// that.$vs.loading.close();
			});
		},
		get_availabity: function() {
			this.booking_persons = {};
			let that = this;
			that.$vs.loading();
			this.$api({
				method: 'get',
				url: '/myvilagale/bookings/get_availability',
				params: {
					token: this.user_token,
					space_hotel_id: this.space_hotel_selected.space_hotel_id,
					date: moment(this.booking_date_selected).format('YYYY-MM-DD'),
					num_reserva: (this.$route.name === 'int_bookings') ? this.user.hotel.num_reserva : this.reservation_data.num_reserva,
					cod_hotel: this.user.hotel.hotel_id,
					lang: this.$i18n.locale,
					rsv_type_selected: this.rsv_type_selected == null ? null : this.rsv_type_selected.name,
					is_internal: +(this.$route.name === 'int_bookings') // convert bool to 0 or 1
				},
			})
			.then(function (res) {
				if(res.data.schedules.length === 0) {
                    that.notify(that.$t('no_shedules'), 'red');
                    that.service_type_selected = null;
                }
				that.service_types = res.data.service_types;
				if(that.service_types.length === 1) {
					that.service_type_selected = that.service_types[0];
				}
				that.schedules = res.data.schedules;
				that.menus = res.data.menus;
				that.information = res.data.informations[that.$i18n.locale];
				that.informations = res.data.informations;
				that.triggerComp += 1;

				if(that.rsv_type_selected != null && that.rsv_type_selected.name === 'Reserva') {
					that.room_date_selected.num_pessoas = that.user.hotel.num_pessoas;
				}
			}) 
			.catch( function (err) {
				if(err.response.data.message == 'responses.error_date'){
					that.notify( $t('erro_date'), 'red');
				}else{
					that.notify('ERR.3', 'red');
				}
			})
			.then(function() {
				that.$vs.loading.close();
			});
		},
		get_spaces_types: function(reservation_number) {
			let that = this;
			that.$vs.loading();
			this.$api({
				method: 'get',
				url: '/myvilagale/bookings/get_spaces_type',
				params: {
					token: this.user_token,
					cod_hotel: this.user.hotel.hotel_id,
					num_reserva: reservation_number,
					type: this.$route.name,
					lang: this.$i18n.locale,
					is_internal: +(this.$route.name === 'int_bookings'), // convert bool to 0 or 1
					interface: (this.$route.name === 'int_bookings') ? this.$route.params.interface : 1
				},
			}).then(function (res) {
				that.spaces_types = res.data.spaces_types;
				that.reservation_data = res.data.reservation_data;
				if(that.$route.name === 'int_bookings'){
					let checkIn = moment(that.user.hotel.check_in.date).startOf('day');
					if(checkIn > moment(new Date)) { // antes do checkin
						that.booking_date_selected = moment(that.user.hotel.check_in.date).toDate();
						that.datepicker.disabledDates.to = moment(that.user.hotel.check_in.date).toDate();
					}else{
						that.booking_date_selected = moment().startOf('day').toDate();
						that.datepicker.disabledDates.to = moment().startOf('day').toDate();
					}

					that.datepicker.disabledDates.from = moment(that.user.hotel.check_out.date).startOf('day').toDate();
				}else{
					let checkIn = moment(res.data.reservation_data.current_data_check_in).startOf('day');
					if(checkIn > moment(new Date)){ // antes do checkin
						that.booking_date_selected = new Date(res.data.reservation_data.current_data_check_in);
						that.datepicker.disabledDates.to = that.booking_date_selected;
					}else{
						that.booking_date_selected = moment().startOf('day').toDate();
						that.datepicker.disabledDates.to = moment().startOf('day').toDate();
					}
					that.datepicker.disabledDates.from = moment(res.data.reservation_data.current_data_check_out).startOf('day').toDate();
					
				}
				that.user.hotel.hotel_id = res.data.cod_hotel;
				that.room_date_selected = that.reservation_data.rooms[0].prices.find((item, idx) => item.reserva_data === moment(that.booking_date_selected).format('YYYY-MM-DD'));
				that.menus = res.data.menus;
			}).catch( function (err) {
    			that.notify('ERR.1', 'red');
			}).then(function() {
				that.$vs.loading.close();
			});
		},
		keyboard_accept(text) {
          //alert("Input text: " + text);
          this.keyboard_hide();
        },
        keyboard_show(e) {
          this.keyboard.input = e.target;
          this.keyboard.layout = e.target.dataset.layout;
 
          if (!this.keyboard.visible)
            this.keyboard.visible = true
        },
        keyboard_hide() {
          this.keyboard.visible = false;
        },
        getHotelName(){
        	let that = this;
			that.$vs.loading();
			this.$api({
				method: 'get',
				url: '/site/config/hotel/name',
				params: {
					token: this.user_token,
					cod_hotel: this.$route.params.hotelId,
				},
			}).then(function (res) {
				that.user.hotel.hotel_name = (res.data.hotel == null) ? null : res.data.hotel.hvg_desc;
			}).catch( function (err) {
    			that.notify('ERR.16', 'red');
			}).then(function() {
				that.$vs.loading.close();
			});
        }
	},
	computed: {
		show_select_space_hotel: function() {
			return this.space_type_selected !== null
				&& this.space_type_selected.hotel_spaces.length > 0;
		},
		show_select_service_type: function() {
			return this.space_hotel_selected !== null && this.space_type_selected.space_type_id == 1;
		},
		comp_service_types: function() {
			return this.service_types.filter((item, idx) => item.service_type_id !== null);
		},
		load_dish_table: function() {
			if(typeof this.room_date_selected == 'undefined' && this.room_date_selected == null){
				return false;
			}
			return this.load_table && this.comp_subcapitulos.length > 0 && this.rsv_type_selected != null && this.rsv_type_selected.name !== 'Passante' && this.room_date_selected.service_types_available.indexOf(this.service_type_selected.service_type_id) !== -1;
		},
		comp_schedules: {
			get: function() {
				this.triggerComp;
				if(this.service_type_selected === null || typeof this.schedules[this.service_type_selected.service_type_unique_id] === 'undefined') {
					this.booking_persons = {};
					return [];
				}
				let booking_persons_tmp = {};
				for(let s of this.schedules[this.service_type_selected.service_type_unique_id]) {
					if(s.reservation_distribution.length === 0 || typeof s.reservation_distribution === 'undefined') {
						s.reservation_distribution = [{'current_ocupation': 0, 'space_schedule_id': s.space_schedule_id}];
					}
					s.current_ocupation = parseInt(s.reservation_distribution[0].current_ocupation);
					s.maximum_occupancy = s.schedule_maximum_occupancy;
					if(parseInt(s.tables_maximum_occupancy) < parseInt(s.schedule_maximum_occupancy)) {
						s.maximum_occupancy = s.tables_maximum_occupancy;
					}
					s.person_disponibility = s.maximum_occupancy - s.current_ocupation;
					booking_persons_tmp[s.space_schedule_id] = 0;
					if(typeof this.booking_persons[s.space_schedule_id] !== 'undefined') {
						s.booking_num_pessoas = this.booking_persons[s.space_schedule_id];
						booking_persons_tmp[s.space_schedule_id] = this.booking_persons[s.space_schedule_id];
					}
				}
				this.booking_persons = booking_persons_tmp;
				return this.schedules[this.service_type_selected.service_type_unique_id].filter((item, idx) => item.person_disponibility > 0);
			},
			set: function(newValue) {
				return newValue;
			}
		},
		comp_subcapitulos: {
			get: function() {
				this.triggerComp;
				if(!this.load_table
					|| this.service_type_selected === null
					|| this.service_type_selected.menu_id === null
					|| this.menus === null
					|| typeof this.menus[this.service_type_selected.menu_id] === 'undefined'
					|| this.menus[this.service_type_selected.menu_id][0].capitulos.length === 0
					) {
					
					return [];
				}
				return this.menus[this.service_type_selected.menu_id][0].capitulos[0].sub_capitulos;
			},
			set: function(newValue) {
				return newValue;
			}
		},
		load_table: function() {
			return (this.space_hotel_selected !== null && this.comp_service_types.length === 0 && this.comp_schedules.length > 0) || (this.service_type_selected !== null && this.comp_schedules.length > 0);
		},
		total_schedule_num_pessoas: function() {
			return Object.values(this.booking_persons).reduce((current_sum, val) => current_sum + val, 0);
		},
		total_dish_num_pessoas: function() {
			return this.comp_subcapitulos.reduce((current_sum, val) => current_sum + parseInt(val.num_pessoas_dish), 0);
		},
		can_confirm: function() {
			if(this.space_type_selected !== null && this.space_hotel_selected !== null && this.service_type_selected !== null) {
				if(typeof this.room_date_selected != 'undefined' && this.room_date_selected != null){
					if(this.room_date_selected.service_types_available.indexOf(this.service_type_selected.service_type_id) === -1 && this.total_schedule_num_pessoas > 0) {
						return true;
					}
				}
				if(this.comp_subcapitulos.length > 0) {
					if(this.$route.name === 'int_bookings' && this.total_schedule_num_pessoas > 0) {
						return true;
					}
					else if(this.total_dish_num_pessoas > 0 && this.total_schedule_num_pessoas > 0) {
						return this.total_dish_num_pessoas === this.total_schedule_num_pessoas;
					}
				}
				else if(this.comp_subcapitulos.length === 0 && this.total_schedule_num_pessoas > 0) {
					return true;
				}
			}
			return false;
		},
	},
	watch: {
		space_type_selected: function(new_val, old_val) {
			if(new_val !== null) {
				if(new_val.hotel_spaces.length === 1) {
					this.space_hotel_selected = new_val.hotel_spaces[0];
				}
				else if(new_val.hotel_spaces.length === 0) {
					this.$vs.notify({
	                    text: this.$t('no_spaces'),
	                    color:'danger',
	                    position:'bottom-right',
	                    iconPack: 'feather',
	                    icon:'icon-check'
	                });
				}
			}
		},
		service_type_selected: function(new_val, old_val) {
			this.comp_subcapitulos = this.comp_subcapitulos.map((item, idx) => item.num_pessoas_dish = 0);
			if(new_val !== null) {
				for(let s of this.schedules[new_val.service_type_unique_id]) {
					s.booking_num_pessoas = 0;
				}
				this.booking_persons = {};
			}
		},
		space_hotel_selected: function(new_val, old_val) {
			if(new_val !== null) {
				this.comp_subcapitulos = this.comp_subcapitulos.map((item, idx) => item.num_pessoas_dish = 0);
				this.booking_persons = {};
				this.get_availabity();
			}else{
				this.information = null;
			}
		},
		booking_date_selected: function(new_val, old_val) {
			if(this.reservation_data === null)
				return;
			if(this.$route.name === 'int_bookings') { // set room price for date selected
				this.reservation_data.rooms[0].prices[0].reserva_data = moment(new_val).format('YYYY-MM-DD');
			}
			this.room_date_selected = this.reservation_data.rooms[0].prices.find((item, idx) => item.reserva_data === moment(new_val).format('YYYY-MM-DD'));
			if(this.rsv_type_selected != null && this.rsv_type_selected.name == 'Passante' && this.space_type_selected !== null && this.space_type_selected.hotel_spaces.length > 1) {
				this.space_hotel_selected = null;
			}
			if(this.space_hotel_selected !== null) {
				this.comp_subcapitulos = this.comp_subcapitulos.map((item, idx) => item.num_pessoas_dish = 0);
				/*this.booking_persons = {};*/
				this.get_availabity();
			}
			else {
				this.schedules = {};
				//this.triggerComp += 1;
			}
		},
		can_confirm: function(new_val, old_val) {
			if(!new_val) {
				this.associate_rsv = false;		
			}
		},
		associate_rsv: function(new_val, old_val) {
			if(!new_val) {
				this.associated_rsv_number = null;
				this.associated_rsv_room_number = null;
			}
		},
		rsv_type_selected: function(new_val, old_val) {
			if(new_val.name === 'Reserva' && !this.show_pop_up_int_booking) {
				this.show_pop_up_int_booking = true;
			}
			this.reset_all(true);
		},
		show_pop_up_int_booking: function(new_val, old_val) {
			this.int_booking_rsv = {num_reserva: '', room_number: '', name: ''};
			if(!new_val && this.user.hotel.num_reserva === null) {
				this.reset_all(false);
				this.keyboard_hide();
			}
		},
		triggerComp: function(new_val, old_val) {
			if(this.service_type_selected !== null && (this.comp_schedules.length === 0 || this.schedules.length === 0)) {
				this.$vs.notify({
                    text: this.$t('no_shedules'),
                    color:'danger',
                    position:'bottom-right',
                    iconPack: 'feather',
                    icon:'icon-check'
                });
			}
		},
		'$i18n.locale': function(new_value, old_val) {
			this.information = this.informations[new_value];
			this.reset_all(true);
		},
		client_reservations_selected: function(new_value, old_val) {
			this.reset_all(true, true, false);
		},
	},
	created() {
		if(this.$route.name === 'int_bookings') {
			this.user = {
				usertoken: this.$route.params.token,
				hotel: {
					hotel_id: this.$route.params.hotelId,
					hotel_name: null,
					num_reserva: null,
					room_number: null,
					nome: null,
					check_in: {
						date: this.datepicker.disabledDates.to
					},
					check_out: {
						date: moment(this.booking_date_selected).add(2, 'months').format('YYYY-MM-DD')
					}
				}
			};
			this.user_token = this.$route.params.token;
			this.getHotelName();
		}else {
			this.user.hotel.hotel_id = null;
			this.user_token = this.user.usertoken;
			this.client_reservations = this.user.bookingList;
		}
	},
}
</script>

<style>
	.bookings-page .booking-date .vdp-datepicker__calendar {
		bottom: auto;
	}
</style>
<style scoped>
	.table_schedule_wrapper {
		position: relative;
		z-index: 0;
	}
	.table_schedule_wrapper .vs-input-number, .table_dish_wrapper .vs-input-number {
		background-color: transparent;
	}
	.logo-text{
		font-size: 26px;
		font-weight: 600;
		color: #4A4E4F;
		animation: 0.3s cubic-bezier(0.25, 0.8, 0.25, 1) 0s normal forwards 1 fadein;
		font-family: 'Titillium Web',sans-serif;
	}
    .v-touch-keyboard {
    	z-index: 99999;
    	background-color: #ffffff;
    	position: fixed;
    	width: 70%;
    	left: 0;
	    right: 0;
	    bottom: 0;
	    margin: auto auto;
	    padding: 1em;
	    box-shadow: 0px -3px 10px rgba(0, 0, 0, 0.3);
	    border-radius: 10px;
    }
    .v-touch-keyboard >>> .keyboard .key {
    	font-size: 1.45em;
    }
    .observations-textarea {
    	width: 100%;
    	height: 150px;
    	margin-bottom: 15px;
    	font-family: inherit;
    	border-radius: 5px;
    	border: 1px solid rgba(0,0,0,0.2);
    }
    .observations-textarea:focus {
    	border: 1px solid rgba(var(--vs-primary),1)!important;
    }
    /*.v-touch-keyboard >>> .keyboard .key {
	    height: 2.5em;
	    padding-top: 2px;
	}*/
	@media screen and (max-width: 992px) {
		.v-touch-keyboard {
	    	width: 100%;
		}
	}

	@media (max-width: 640px) {
		.rsv_data.flex {
			display:block !important;
		}

		.rsv_data.flex p {
			margin-top: 15px;
		}
	}
</style>
